import {
    DELETE_USER,
    DELETE_USER_FAILURE,
    DELETE_USER_MEMBERSHIP,
    DELETE_USER_MEMBERSHIP_FAILURE,
    DELETE_USER_MEMBERSHIP_SUCCESS,
    DELETE_USER_SUCCESS,
} from 'store/actions/types';

export const deleteUser = (payload) => {
    return {
        type: DELETE_USER,
        payload: payload,
    };
};

export const deleteUserFailure = (error) => {
    return {
        type: DELETE_USER_FAILURE,
        error: error,
    };
};

export const deleteUserSuccess = (payload) => {
    return {
        type: DELETE_USER_SUCCESS,
        payload: payload,
    };
};

export const deleteUserMembership = (payload) => {
    return {
        type: DELETE_USER_MEMBERSHIP,
        payload: payload,
    };
};

export const deleteUserMembershipFailure = (error) => {
    return {
        type: DELETE_USER_MEMBERSHIP_FAILURE,
        error: error,
    };
};

export const deleteUserMembershipSuccess = () => {
    return {
        type: DELETE_USER_MEMBERSHIP_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/deleteUsers.js